import {ModalTiteledWindow} from "./modalWindow.js";
import {DataView} from '../dataview.js';
import {groupClassNames} from '../util.js';

export class ModalShowTimetableItem extends ModalTiteledWindow {

   constructor(type, items, dm) {
      super();
      this.dm = dm;
      this.load(type, items);
      this.panel.classList.add('modal-show-timetable-item');
   }

   load(type, items) {

      this.user = this.dm.getUserSelf();

      const tmpl = document.getElementById('tpl-modal-show-timetable-item');
      const elContainer = tmpl.content.cloneNode(true);
      const elTimetable = elContainer.querySelector('.timetable');

      for (let i=0; i<items.length; ++i) {
         const item = items[i];

         const elItem = elTimetable.createElement('div', 'timetable-item');

         if (type === 'teacher') {
            let classNames = '';
            if (item.course) {
               const classes = item.course.classes.map(cls => { return this.dm.getClass(cls); });
               classNames = this.user.type === 'teacher' ? groupClassNames(classes) : '';
            }
            elItem.innerHTML = `<div class="class">${classNames}</div> <div class="title">${item.title}</div> <div class="room">${item.rooms.map((id) => { return this.dm.getRoom(id).short; }).join(',')}</div>`;
         }
         else if (type === 'room') {
            let classNames = '';
            if (item.course) {
               const classes = item.course.classes.map(cls => { return this.dm.getClass(cls); });
               classNames = this.user.type === 'teacher' ? groupClassNames(classes) : '';
            }
            const teachers = item.teachers.map((id) => this.dm.getUser(id).short).join(',');
            elItem.innerHTML = `<div class="teachers">${teachers}</div> <div class="title">${item.title}</div> <div class="room">${classNames}</div>`;
         }
         else if (type === 'class') {
            const teachers = item.teachers.map((id) => this.dm.getUser(id).short).join(',');
            const title    = item.title;
            const rooms    = item.rooms.map((id) => this.dm.getRoom(id).short).join(',');
            elItem.innerHTML = `<div class="teachers">${teachers}</div> <div class="title">${title}</div> <div class="room">${rooms}</div>`;
         }
         else {
            const teachers = item.teachers.map((id) => this.dm.getUser(id).short).join(',');
            elItem.innerHTML = `<div class="teachers">${teachers}</div> <div class="title">${item.title}</div> <div class="room">${item.rooms.map((id) => { return this.dm.getRoom(id).short; }).join(',')}</div>`;
         }

      }


      const elPupils = elContainer.querySelector('.pupils');


      let listSettings = {
         columns: [
            {
               title: 'Nachname',
               data: 'lastName',
               sort: { index: 1, dir: 1 },
               css: { height: '1.5rem' }
            },
            {
               title: 'Vorname',
               data: 'firstName',
               sort: { index: 2, dir: 1 }
            },
            {
               title: 'Klasse',
               data: (pupil) => {
                  return pupil.class.name;
               },
               sort: { index: 3, dir: 1, value: function(pupil) {
                  return (pupil.class.name.search(/^\d\d/) === -1) ? '0' + pupil.class.name : pupil.class.name;
               }}

            }
         ]
      };

      if (this.user.type === 'teacher') {
         for (let item of items) {
            if (item.course) {
               let elCourseTitle = elPupils.createElement('div', 'course-title');
               elCourseTitle.innerHTML = 'Schülerliste ' + item.title + ' (' + item.course.pupils.length + ')';
               let elList = elPupils.createElement('div', 'pupils-list');
               let pupils = item.course.pupils.map(id => { return this.dm.getPupil(id) });
               pupils = pupils.filter(pupil => pupil);
               this.list = new DataView(elList);
               this.list.load(pupils, listSettings);
            }
         }
      }




      /*
      this.list = new DataView(container.querySelector('.list'));

      if (settings.hasOwnProperty('list')) {
         container.querySelector('.classes').hidden = '';
         this.loadPupils(settings.list);
      }
      else if (settings.hasOwnProperty('classes')) {

         const classes = container.querySelector('.classes');

         for (const cls of settings.classes) {
            let btn = classes.createElement('div', 'select-class');
            btn.setStyles({ display: 'inline-block', backgroundColor: '#3A78FF', borderRadius: '40%', padding: '.3rem 1rem', marginRight: '.2rem', color: '#333', fontWeight: 'bold' });
            btn.innerHTML = this.dm.getClass(cls).name;
            btn.dataset.classId = cls;
            btn.addEventListener('click', event => {
               event.stopPropagation();
               event.target.parentNode.querySelectorAll('.select-class').removeClass('selected');
               event.target.classList.add('selected');
               this.loadPupilsOfClass(parseInt(event.currentTarget.dataset.classId));
            });
         }

         let btn = classes.createElement('div', 'select-class');
         btn.setStyles({ display: 'inline-block', backgroundColor: '#3A78FF', borderRadius: '40%', padding: '.3rem 1rem', marginRight: '.2rem', color: '#333', fontWeight: 'bold' });
         btn.innerHTML = 'alle';
         btn.addEventListener('click', event => {
            event.stopPropagation();
            event.target.parentNode.querySelectorAll('.select-class').removeClass('selected');
            event.target.classList.add('selected');
            this.loadAllPupils();
         });

      }*/

      this.setTitle('Stundenplan');
      this.appendToBody(elContainer);

      setTimeout(() => this.show(), 1);

   }
   /*
   loadPupils(pupilIds) {

      let pupils = pupilIds.filter(id => { return !this.ignoreList.includes(id); }).map(id => { return this.dm.getPupil(id) });



   }
   */

}
